import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface UnplayableNoticeProps {
  errors: string[];
  onExit?: () => void;
}

export const UnplayableNotice = ({ errors, onExit }: UnplayableNoticeProps) => (
  <Card className="border-destructive/40">
    <CardContent className="p-6 space-y-4">
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-6 w-6 text-destructive shrink-0 mt-0.5" />
        <div>
          <h3 className="font-semibold">This game can't be played right now</h3>
          <p className="text-sm text-muted-foreground mt-1">
            The activity didn't pass our renderer checks. Please try generating a new one.
          </p>
        </div>
      </div>
      {errors.length > 0 && (
        <details className="text-xs text-muted-foreground">
          <summary className="cursor-pointer">Technical details</summary>
          <ul className="mt-2 list-disc pl-4 space-y-0.5">
            {errors.slice(0, 8).map((e, i) => (
              <li key={i}>{e}</li>
            ))}
          </ul>
        </details>
      )}
      {onExit && (
        <Button variant="outline" onClick={onExit}>
          Back
        </Button>
      )}
    </CardContent>
  </Card>
);
